<div class="vl"></div>
<ion-buttons class="close" slot="primary">
  <ion-button class="btn-round" (click)="dismiss()">
    <ion-icon slot="icon-only" name="close" size="small"></ion-icon>
  </ion-button>
</ion-buttons>
<div class="content">
  <div class="head">
    <img class="green" src="assets/img/icon-notes.svg" />
    <img class="white" src="assets/img/icon-notes-white.svg" />
    <span>{{'__VIDEOCHAT_NOTES_HEADER__' | translate}}</span>
  </div>

  <div class="contents">
    <div id="message-wrap" class="note-container message-wrap">

    </div>

    <div class="add-notes">
      <ion-input required #chat_input class="title" placeholder="{{'__VIDEOCHAT_NOTES_TYPING_PLACEHOLDER__' | translate}}"></ion-input>
      <button class="btn-round btn-round-black"><img src="assets/img/icon-save.svg"></button>
    </div>
  </div>
</div>